module.exports = __webpack_public_path__ + "static/img/exploit4.00ad4a59.png";